(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["find-a-store-map"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function initRoot(root) {
      var payloadEl = root.querySelector('script[data-fasm-payload]');
      if (!payloadEl) return;
      var payload;
      try { payload = JSON.parse(payloadEl.textContent); } catch (e) { return; }
      var mapEl = document.getElementById(payload.mapId);
      if (!mapEl || mapEl._fasmInit) return;
      mapEl._fasmInit = true;

      var byCountry = {};
      payload.locations.forEach(function (loc) {
        var lat = parseFloat(loc.lat);
        var lng = parseFloat(loc.lng);
        if (isNaN(lat) || isNaN(lng)) return;
        (byCountry[loc.country] = byCountry[loc.country] || []).push({
          lat: lat, lng: lng, name: loc.name
        });
      });

      var pinIconInner;
      if (payload.pinIconUrl) {
        // Masked span, not an <img>: the colour comes from CSS
        // (--fasm-pin-icon-color) so the uploaded file's own colours are
        // irrelevant. See the mask rule in the stylesheet below.
        pinIconInner = '<span class="fasm-pin__img" aria-hidden="true"></span>';
      } else {
        // Default: Feather-style coffee cup outline (currentColor stroke → inherits container color).
        pinIconInner =
          '<svg class="fasm-pin__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
          'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M17 8h1a4 4 0 0 1 0 8h-1"/>' +
          '<path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V8z"/>' +
          '<line x1="6" y1="2" x2="6" y2="4"/>' +
          '<line x1="10" y1="2" x2="10" y2="4"/>' +
          '<line x1="14" y1="2" x2="14" y2="4"/>' +
          '</svg>';
      }

      var pinIcon = L.divIcon({
        className: 'fasm-pin',
        html: '<span class="fasm-pin__container">' + pinIconInner + '</span>',
        iconSize: [32, 32],
        iconAnchor: [16, 16]
      });

      var map = L.map(mapEl, { scrollWheelZoom: false }).setView([13, 122], 5);
      // Harlan customisation: remove Leaflet's self-credit prefix. That is the
      // library crediting itself and is not required by any licence — Leaflet
      // is BSD-licensed. The Esri / OpenStreetMap data credit that follows IS
      // required (Esri's terms + OSM's ODbL) and must not be removed.
      if (map.attributionControl) map.attributionControl.setPrefix('');
      // Harlan customisation: basemap moved off CartoDB Positron to Esri's
      // World Light Gray Canvas. CARTO now require an API key for their
      // basemaps and stamp unkeyed tiles with "API KEY REQUIRED /
      // carto.com/basemaps" INSIDE the tile image, so it could not be hidden
      // with CSS. Esri's equivalent is free and keyless.
      //
      // Esri splits the basemap from its labels, so two layers are stacked:
      // the base canvas, then a transparent reference layer carrying street
      // and place names. Without the second one the map is unusably anonymous
      // for a store locator.
      //
      // Esri serves {z}/{y}/{x} — y before x, the reverse of the usual XYZ
      // scheme. Getting that round the wrong way yields a map of the wrong
      // hemisphere rather than an error, so leave the order alone.
      //
      // maxZoom drops 20 -> 16: Esri's Light Gray Canvas has no tiles beyond
      // 16 and would otherwise render blank at closer zooms.
      //
      // Attribution is required by Esri's terms and OpenStreetMap's licence.
      // Do not lose on theme update.
      L.tileLayer(
        'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
        {
          attribution:
            'Tiles &copy; <a href="https://www.esri.com/">Esri</a> &mdash; Esri, HERE, Garmin, &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          maxZoom: 16
        }
      ).addTo(map);

      L.tileLayer(
        'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}',
        { maxZoom: 16, pane: 'overlayPane' }
      ).addTo(map);
      var markerGroup = L.layerGroup().addTo(map);

      // Match card by lat/lng attributes. Store coords are stringified in the
      // metaobject, cards read them back as strings — compare via parseFloat +
      // small tolerance to avoid trailing-decimal drift.
      function findCardForLatLng(lat, lng) {
        var cards = root.querySelectorAll('.find-a-store-map__card[data-fasm-lat]');
        for (var i = 0; i < cards.length; i++) {
          var cLat = parseFloat(cards[i].getAttribute('data-fasm-lat'));
          var cLng = parseFloat(cards[i].getAttribute('data-fasm-lng'));
          if (!isNaN(cLat) && !isNaN(cLng) &&
              Math.abs(cLat - lat) < 1e-5 && Math.abs(cLng - lng) < 1e-5) {
            return cards[i];
          }
        }
        return null;
      }

      // Single-open expand: closes any other expanded card in the same panel.
      // Options: { toggle: true } → collapse if already expanded (card-click
      // behaviour). Default (from pin-click) always expands, never collapses.
      function expandCard(card, options) {
        options = options || {};
        var wasExpanded = card.classList.contains('is-expanded');
        var panel = card.closest('.find-a-store-map__panel');
        if (panel) {
          panel.querySelectorAll('.find-a-store-map__card.is-expanded').forEach(function (c) {
            if (c !== card) c.classList.remove('is-expanded');
          });
        }
        if (wasExpanded && options.toggle) {
          card.classList.remove('is-expanded');
          return false;
        }
        card.classList.add('is-expanded');
        return true;
      }

      function showTab(tab) {
        markerGroup.clearLayers();
        var list = byCountry[tab] || [];
        if (list.length === 0) return;
        var latlngs = [];
        list.forEach(function (l) {
          var m = L.marker([l.lat, l.lng], { icon: pinIcon }).addTo(markerGroup);
          if (l.name) {
            var placeUrl = 'https://www.google.com/maps/search/?api=1&query=' +
              encodeURIComponent(l.lat + ',' + l.lng);
            m.bindPopup(
              '<a class="fasm-popup-link" href="' + placeUrl + '" target="_blank" rel="noopener">' +
              '<strong>' + escapeHtml(l.name) + '</strong></a>'
            );
          }
          // Symmetric interaction: pin click → highlight+expand+scroll the
          // matching card in the list. Popup opens too (Leaflet default) so
          // user gets both the place link (popup) and the card actions
          // (accordion GET DIRECTIONS). Does not re-center the map (already
          // there — avoids a redundant pan animation).
          m.on('click', function () {
            // Harlan customisation: the clicked pin gets .is-selected so it can
            // be coloured differently from the rest. Cleared from every other
            // marker first, so only one is ever lit. markerGroup is emptied and
            // rebuilt on tab switch, so the state resets by itself.
            markerGroup.eachLayer(function (layer) {
              var el = layer.getElement && layer.getElement();
              if (el) el.classList.remove('is-selected');
            });
            var self = m.getElement && m.getElement();
            if (self) self.classList.add('is-selected');

            var card = findCardForLatLng(l.lat, l.lng);
            if (!card) return;
            expandCard(card);
            scrollCardToTop(card);
          });
          latlngs.push([l.lat, l.lng]);
        });
        if (latlngs.length === 1) {
          map.setView(latlngs[0], payload.defaultZoom || 13);
        } else {
          map.fitBounds(latlngs, { padding: [40, 40], maxZoom: 12 });
        }
      }

      function activateTab(tab, doScroll) {
        var btn = null;
        root.querySelectorAll('.find-a-store-map__pill').forEach(function (b) {
          var active = b.getAttribute('data-fasm-tab') === tab;
          if (active) btn = b;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (!btn) return false;
        root.querySelectorAll('[data-fasm-panel]').forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-fasm-panel') === tab);
        });
        // Toggle geo-button slot visibility — one button per country lives
        // outside the panel scroll container, so its visibility must be
        // driven independently (unlike panels which have .is-active class).
        root.querySelectorAll('[data-fasm-btn-slot]').forEach(function (s) {
          s.hidden = s.getAttribute('data-fasm-btn-slot') !== tab;
        });
        // Clear stale "nearest" result — the highlighted card + banner
        // referred to the previous country's nearest, which is meaningless
        // in the newly-active tab. User has to click the button again.
        clearBannersAndHighlights();
        showTab(tab);
        setTimeout(function () { map.invalidateSize(); }, 50);
        if (doScroll) {
          try { btn.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
          catch (e) { btn.scrollIntoView(); }
        }
        return true;
      }

      function tabFromHash() {
        var h = decodeURIComponent((window.location.hash || '').replace(/^#/, ''));
        if (!h) return null;
        var sel = (window.CSS && CSS.escape) ? CSS.escape(h) : h;
        var match = root.querySelector('.find-a-store-map__pill[data-fasm-tab="' + sel + '"]');
        return match ? h : null;
      }

      root.querySelectorAll('[data-fasm-tab]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          activateTab(btn.getAttribute('data-fasm-tab'), false);
        });
      });

      window.addEventListener('hashchange', function () {
        var t = tabFromHash();
        if (t) activateTab(t, true);
      });

      root.querySelectorAll('.find-a-store-map__card').forEach(function (card) {
        var lat = parseFloat(card.getAttribute('data-fasm-lat'));
        var lng = parseFloat(card.getAttribute('data-fasm-lng'));
        if (isNaN(lat) || isNaN(lng)) return;
        card.classList.add('is-clickable');
        card.addEventListener('click', function (ev) {
          // Directions link handles its own click — don't toggle accordion.
          if (ev.target.closest('[data-fasm-directions]')) return;
          var expanded = expandCard(card, { toggle: true });
          if (expanded) {
            map.setView([lat, lng], 15, { animate: true });
          }
        });
      });

      // Great-circle distance in kilometres via the Haversine formula.
      // Accurate to <0.5% for the distances we care about (up to a few
      // thousand km); more than enough for a "nearest store" picker.
      function haversineKm(lat1, lon1, lat2, lon2) {
        var R = 6371;
        var toRad = Math.PI / 180;
        var dLat = (lat2 - lat1) * toRad;
        var dLon = (lon2 - lon1) * toRad;
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return 2 * R * Math.asin(Math.sqrt(a));
      }

      function clearBannersAndHighlights() {
        root.querySelectorAll('[data-fasm-geo-banner]').forEach(function (b) {
          b.hidden = true;
          b.classList.remove('is-result', 'is-error');
        });
        root.querySelectorAll('.find-a-store-map__card.is-nearest').forEach(function (c) {
          c.classList.remove('is-nearest');
        });
      }

      function showBannerError(banner, message) {
        var label = banner.querySelector('[data-fasm-banner-label]');
        label.textContent = message;
        banner.classList.remove('is-result');
        banner.classList.add('is-error');
        banner.hidden = false;
      }

      function showBannerResult(banner, btn, store, distanceKm, userLat, userLng) {
        var label = banner.querySelector('[data-fasm-banner-label]');
        var cta = banner.querySelector('[data-fasm-banner-cta]');
        var ctaText = banner.querySelector('[data-fasm-banner-cta-text]');

        var distStr = distanceKm < 10 ? distanceKm.toFixed(1) : Math.round(distanceKm).toString();
        label.textContent = btn.dataset.labelNearest.toUpperCase() + ' · ' +
                            store.name + ' · ' + distStr + ' ' + btn.dataset.labelKmAway;

        // Google Maps universal directions URL. Deep-links to the app on
        // iOS + Android, opens Maps web on desktop. Passing both origin
        // (user's geoloc) + destination gives an immediate route with no
        // extra Maps-side prompt.
        cta.href = 'https://www.google.com/maps/dir/?api=1' +
                   '&origin=' + userLat + ',' + userLng +
                   '&destination=' + store.lat + ',' + store.lng;
        ctaText.textContent = btn.dataset.labelDirections;

        banner.classList.remove('is-error');
        banner.classList.add('is-result');
        banner.hidden = false;
      }

      // Harlan customisation: bring a card to the TOP of the list rather than
      // just barely into view. scrollIntoView({block:'start'}) would do it, but
      // it scrolls EVERY scrollable ancestor, so on mobile — where
      // .find-a-store-map__panels is overflow-y: visible and the page itself is
      // the scroller — it yanks the whole page. Scrolling the panels container
      // directly keeps the movement inside the list on desktop, and falls back
      // to scrollIntoView only when the container is not actually scrollable.
      function scrollCardToTop(card) {
        var scroller = card.closest('.find-a-store-map__panels');
        if (scroller && scroller.scrollHeight > scroller.clientHeight + 1) {
          var delta = card.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
          try {
            scroller.scrollTo({ top: scroller.scrollTop + delta, behavior: 'smooth' });
          } catch (e) {
            scroller.scrollTop = scroller.scrollTop + delta;
          }
          return;
        }
        try { card.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        catch (e) { card.scrollIntoView(); }
      }

      function highlightAndPan(panel, store) {
        panel.querySelectorAll('.find-a-store-map__card').forEach(function (card) {
          var lat = parseFloat(card.getAttribute('data-fasm-lat'));
          var lng = parseFloat(card.getAttribute('data-fasm-lng'));
          if (isNaN(lat) || isNaN(lng)) return;
          // Coord equality via absolute-diff instead of === because the
          // marker's store.lat/lng came from parseFloat of Liquid-emitted
          // strings, and card data-lat/lng also parseFloat'd — floating
          // point round-trip through IEEE754 can differ in the last bit.
          if (Math.abs(lat - store.lat) < 0.0001 && Math.abs(lng - store.lng) < 0.0001) {
            card.classList.add('is-nearest');
            try {
              scrollCardToTop(card);
            } catch (e) {
              card.scrollIntoView();
            }
          }
        });

        map.setView([store.lat, store.lng], 15, { animate: true });

        markerGroup.eachLayer(function (m) {
          if (!m.getLatLng) return;
          var pos = m.getLatLng();
          if (Math.abs(pos.lat - store.lat) < 0.0001 && Math.abs(pos.lng - store.lng) < 0.0001) {
            m.openPopup();
          }
        });
      }

      function handleGeoClick(btn) {
        var country = btn.dataset.country;
        var panel = btn.closest('.find-a-store-map__panel');
        var banner = root.querySelector('[data-fasm-geo-banner]');
        var btnText = btn.querySelector('[data-fasm-geo-btn-text]');
        var stores = byCountry[country] || [];

        if (stores.length === 0) {
          showBannerError(banner, btn.dataset.labelErrNoData);
          return;
        }
        if (!navigator.geolocation) {
          showBannerError(banner, btn.dataset.labelErrUnavail);
          return;
        }

        btn.disabled = true;
        btnText.textContent = btn.dataset.labelLoading;

        navigator.geolocation.getCurrentPosition(
          function (pos) {
            btn.disabled = false;
            btnText.textContent = btn.dataset.labelIdle;

            var userLat = pos.coords.latitude;
            var userLng = pos.coords.longitude;
            var nearest = null, minDist = Infinity;
            stores.forEach(function (s) {
              var d = haversineKm(userLat, userLng, s.lat, s.lng);
              if (d < minDist) { minDist = d; nearest = s; }
            });
            if (!nearest) {
              showBannerError(banner, btn.dataset.labelErrNoData);
              return;
            }
            showBannerResult(banner, btn, nearest, minDist, userLat, userLng);
            highlightAndPan(panel, nearest);
          },
          function (err) {
            btn.disabled = false;
            btnText.textContent = btn.dataset.labelIdle;
            var msg = err && err.code === 1
              ? btn.dataset.labelErrDenied
              : btn.dataset.labelErrUnavail;
            showBannerError(banner, msg);
          },
          { timeout: 10000, maximumAge: 60000, enableHighAccuracy: false }
        );
      }

      root.querySelectorAll('[data-fasm-geo-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () { handleGeoClick(btn); });
      });

      var bannerCloseBtn = root.querySelector('[data-fasm-banner-close]');
      if (bannerCloseBtn) {
        bannerCloseBtn.addEventListener('click', function () {
          clearBannersAndHighlights();
        });
      }

      var initialTab = tabFromHash();
      if (initialTab) activateTab(initialTab, true);
      else showTab(payload.defaultTab);
      setTimeout(function () { map.invalidateSize(); }, 200);
    }

    function whenLeaflet(cb) {
      if (window.L && window.L.map) return cb();
      setTimeout(function () { whenLeaflet(cb); }, 60);
    }

    document.querySelectorAll('[data-fasm-root]').forEach(function (root) {
      whenLeaflet(function () { initRoot(root); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
